module.exports = __webpack_public_path__ + "img/qricon.5796f3e0.png";